import { render, staticRenderFns } from "./AutocompleteArea.vue?vue&type=template&id=b4c8d93e&scoped=true"
import script from "./AutocompleteArea.vue?vue&type=script&lang=js"
export * from "./AutocompleteArea.vue?vue&type=script&lang=js"
import style0 from "./AutocompleteArea.vue?vue&type=style&index=0&id=b4c8d93e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c8d93e",
  null
  
)

export default component.exports